<!--
手机选择列表
-->

<template>
    <div class="phone-selector-wrap">
        <div class="list">
            <div class="item" v-for="item in list" :key="item.id" @click="doSelect(item)">
                <div class="phone">
                    {{item.phone}}
                </div>
                <div class="time">
                    绑定时间：{{item.createTime}}
                </div>
                <Icon v-if="item.id == id" class="icon-checkbox" :img="require('../../assets/icon-checkbox-selected.png')" />
            </div>
        </div>
        <div class="no-data" v-if="!loading && list.length <= 0">
            暂无手机号码记录
        </div>
        <div class="actions">
            <a href="javascript:;" @click="showAddPhoneDialog" v-show="!loading">添加手机号码</a>
        </div>

        <div class="add-phone-dialog" v-show="form.show">
            <div class="wrap">
                <div class="title">
                    添加手机号码
                    <a href="javascript:;" class="close-btn" @click="closeAddPhoneDialog"></a>
                </div>
                <div class="form">
                    <div class="controller">
                        <label>手机号码</label>
                        <input type="tel" placeholder="请输入手机号码" class="full" v-model="form.phone"  @blur="onBlur">
                    </div>
                    <div class="controller">
                        <label>图形验证</label>
                        <input type="number" placeholder="" class="half" v-model="form.captchaCode" maxlength="4" @blur="onBlur">
                        <div class="captcha" v-if="form.captchaImg" :style="{backgroundImage: `url(${form.captchaImg})`}" @click="changeCaptcha"></div>
                    </div>
                    <div class="controller">
                        <label>短信验证码</label>
                        <input type="number" placeholder="" class="half" v-model="form.smsCode" maxlength="4"  @blur="onBlur">
                        <a href="javascript:;" class="sms-btn" @click="sendSms" :class="{'disable': form.sentStatus != 'init'}">
                            <template v-if="form.sentStatus == 'init'">
                                获取
                            </template>
                            <template v-if="form.sentStatus == 'sending'">
                                发送中
                            </template>
                            <template v-if="form.sentStatus == 'sent'">
                                {{countdown}}秒
                            </template>
                        </a>
                    </div>
                    <div class="form-actions">
                        <a href="javascript:;" @click="doAddPhone">提交</a>
                    </div>
                </div>
            </div>
            <div class="mask"></div>
        </div>
    </div>
</template>

<script>
import BottomAction from "@/components/common/BottomAction";
import api from "../../api";

const PhoneReg = /^1[3456789]\d{9}$/;

var countdownTimer;

export default {
  props: ["id"],
  components: {BottomAction},
  data() {
    return {
      loading: true,
      list: [
        //   {
        //       id: 0,
        //       phone: '1501727670',
        //       createTime: 'sdfsdf'
        //   }
      ],
      countdown: 60,
      form: {
        show: false,
        sentStatus: "init", //sending, sent
        phone: "",
        captchaImg: "",
        captchaId: "",
        captchaCode: "",
        smsCode: ""
      }
    };
  },
  watch: {},
  methods: {
    loadData() {
      this.loading = true;
      this.$showLoading("加载中");
      clearInterval(countdownTimer)
      this.list = [];
      api.user.userPhoneAddressList(
        r => {
          r.list.forEach(it => {
            if (this.id == it.id) {
              it.selected = true;
            } else {
              it.selected = false;
            }
            this.list.push(it);
          });
          this.loading = false;
          this.$hideLoading();
        },
        r => {}
      );
    },
    showAddPhoneDialog() {
      this.form.show = true;
      this.changeCaptcha();
    },
    closeAddPhoneDialog() {
      this.form.show = false;
      this.form.sentStatus = "init";
    },
    changeCaptcha() {
      this.form.captchaCode = "";
      this.$showLoading("刷新中");
      api.user.userPhoneAddressCaptcha(
        r => {
          console.log(r);
          this.form.captchaImg = r.imageData;
          this.form.captchaId = r.id;
          this.$hideLoading();
        },
        r => {
          this.$hideLoading();
          this.$toast(r.msg);
        }
      );
    },
    sendSms() {
      if (this.form.sentStatus != "init") {
        return;
      }

      if (!PhoneReg.test(this.form.phone)) {
        this.$toast("请填写手机号码");
        return;
      }

      if (this.form.captchaCode.length != 4) {
        this.$toast("请填写图形验证码");
        return;
      }

      this.form.sentStatus = "sending";
      api.user.userPhoneAddressSendVerifyCode(
        this.form.captchaCode,
        this.form.captchaId,
        this.form.phone,
        r => {
          console.log(r);
          this.form.sentStatus = "sent";
          this.countdown = 60;
          countdownTimer = setInterval(()=>{
            this.countdown --;
            if(this.countdown <= 0){
              clearInterval(countdownTimer);
              this.form.sentStatus = "init";
            }
          }, 1000);
        },
        r => {
          this.$toast(r.msg);
          this.form.sentStatus = "init";
        }
      );
    },
    doAddPhone() {
      if (!PhoneReg.test(this.form.phone)) {
        this.$toast("请填写手机号码");
        return;
      }

      if (this.form.captchaCode.length != 4) {
        this.$toast("请填写图形验证码");
        return;
      }

      if (this.form.smsCode.length != 4) {
        this.$toast("请填写短信验证码");
        return;
      }
      this.$showLoading("提交中");
      api.user.userPhoneAddressBindPhone(
        this.form.smsCode,
        this.form.phone,
        r => {
          this.$hideLoading();
          this.form.show = false;
          this.$toast("已添加");
          this.loadData();
        },
        r => {
          console.log(r);
          this.$hideLoading();
          this.$toast(r.msg);
        }
      );
    },
    doSelect(item) {
      this.$emit("change", item);
    },
    onBlur(){
      //修复iOS12键盘弹出后页面底部出现空白
      window.scrollTo(0,0);
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="less" scoped>
.phone-selector-wrap {

  .list {
    padding-bottom: 30.67vw;

    .item {
      padding: 2vw 4vw;
      background: #fff;
      position: relative;
      z-index: 1;
      border-bottom: 1px solid #e6e6e6;
      
      .phone {
        font-size: 3.47vw;
        line-height: 6.67vw;
        color: #313131;
      }

      .time {
        font-size: 3.2vw;
        line-height: 5.87vw;
        color: #959595;
      }

      .icon-checkbox{
            display: inline-block;
            width: 4vw;
            height: 4vw;
            border-radius: 50%;
            border: .13vw solid transparent;
            position: absolute;
            right: 4vw;
            top: 50%;
            transform: translateY(-50%);
        }
    }
  }

  .actions {
    position: fixed;
    z-index: 1;
    padding-top: 5.33vw;
    padding-bottom: 12vw;
    bottom: 0;
    left: 0;
    right: 0;
    a {
      background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
      color: #fff;
      height: 12vw;
      width: 92vw;
      line-height: 12vw;
      font-size: 4.26vw;
      border: none;
      display: block;
      margin: 0vw auto;
      border-radius: 6vw;
      text-align: center;
    }
  }

  .no-data {
    line-height: 13.6vw;
    font-size: 3.47vw;
    text-align: center;
    color: #9b9b9b;
  }

  .add-phone-dialog {
    .wrap {
      position: fixed;
      z-index: 999;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      width: 78.4vw;
      border-radius: 0.67vw;
      overflow: hidden;

      .title {
        font-size: 4.4vw;
        color: #3d3d3d;
        text-align: center;
        line-height: 13.6vw;
        border-bottom: 1px solid #d3d3d3;
        .close-btn {
          display: inline-block;
          background-image: url(../../assets/icon-address-close.png);
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          width: 2.67vw;
          height: 2.67vw;
          position: absolute;
          top: (13.6vw - 2.67vw) / 2;
          right: 4.67vw;
        }
      }

      .form {
        padding: 0;
        padding-top: 3.73vw;

        .controller {
          padding-top: 1.87vw;
          padding-bottom: 1.87vw;
          label {
            display: inline-block;
            width: 22.67vw;
            text-align: right;
            color: #393939;
            line-height: 8vw;
            font-size: 3.2vw;

            &:after {
              content: "：";
            }
          }

          input {
            line-height: 7.73vw;
            border: 1px solid #cacaca;
            margin: 0;
            margin-left: 3vw;
            font-size: 3.33vw;
            padding-left: 3.47vw;
            &.full {
              width: 42.87vw;
            }

            &.half {
              width: 23.93vw;
            }

            &::-webkit-input-placeholder {
              color: #cbcbcb;
            }
          }

          .captcha {
            display: inline-block;
            margin-left: 2.27vw;
            height: 8vw;
            width: 16.8vw;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            vertical-align: bottom;
          }

          .sms-btn {
            margin-left: 2.27vw;
            color: #ff0030;
            border: 1px solid #ff0030;
            display: inline-block;
            line-height: 7.47vw;
            padding: 0;
            border-radius: 3.73vw;
            font-size: 3.73vw;
            width: 16.27vw;
            text-align: center;

            &.disable {
              color: #cacaca;
              border-color: #cacaca;
            }
          }
        }

        .form-actions {
          margin-top: 3.73vw;
          a {
            background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
            color: #fff;
            width: 100%;
            line-height: 14vw;
            font-size: 4vw;
            border: none;
            display: block;
            margin: 0vw auto;
            text-align: center;
          }
        }
      }
    }

    .mask {
      background: #000;
      opacity: 0.6;
      z-index: 998;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/common/PhoneSelector.vue